import { LOWER_QUALITY, type RenderQuality } from '../config/rendering.config';

const QUALITIES: readonly RenderQuality[] = ['high', 'medium', 'low'];
const isQuality = (value: string | null): value is RenderQuality => value !== null && (QUALITIES as readonly string[]).includes(value);

/**
 * ?quality=high|medium|low wins, then a stored fallback (written after a device
 * lost its WebGL context), then the device class: touch-first devices get medium.
 */
export function detectQuality(search: string, coarsePointer: boolean, storedFallback: string | null = null): RenderQuality {
  const requested = new URLSearchParams(search).get('quality');
  if (isQuality(requested)) return requested;
  if (isQuality(storedFallback)) return storedFallback;
  return coarsePointer ? 'medium' : 'high';
}

/** The next lighter profile after `current`, or null if there is none. */
export function lowerQuality(current: RenderQuality): RenderQuality | null {
  return LOWER_QUALITY[current] ?? null;
}
